export default __webpack_public_path__ + "static/media/CS.220e3575.png";